import { VaaEmbed } from './VaaEmbed.js';

window.customElements.define('vaa-embed', VaaEmbed);
